export const STRENGTH = {
  get none() { return 0; },
  get weak() { return 20; },
  get medium() { return 60; },
  get strong() { return 100; },
};

export default {
  calculateStrength(passwordText) {
    if (!passwordText) {
      return STRENGTH.none;
    }

    const hasNumber = this.hasNumber(passwordText);
    const hasUpperCase = this.hasUpperCase(passwordText);
    const hasLowerCase = this.hasLowerCase(passwordText);
    const hasSpecialCharacter = this.hasSpecialCharacter(passwordText);

    const hasTotal = [hasNumber, hasUpperCase, hasLowerCase, hasSpecialCharacter]
      .filter(x => x).length;

    if (passwordText.length < 8 || hasTotal < 2) {
      return STRENGTH.none;
    }
    if (hasTotal === 2) {
      return STRENGTH.weak;
    }
    if (hasNumber && hasUpperCase
        && hasLowerCase && hasSpecialCharacter) {
      return STRENGTH.strong;
    }
    return STRENGTH.medium;
  },
  hasNumber(passwordText) {
    return /\d/.test(passwordText);
  },
  hasUpperCase(passwordText) {
    return /[A-Z]/.test(passwordText);
  },
  hasLowerCase(passwordText) {
    return /[a-z]/.test(passwordText);
  },
  hasSpecialCharacter(passwordText) {
    // eslint-disable-next-line
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    return format.test(passwordText);
  },
};
